import { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { parseJwt } from "../../utils/parseJwt";
import { setUserState } from "../../redux/slices/signin-slice";

const USER_TYPE_CANDIDATE = "candidate";

const CandidateAuthGuard = () => {
  const dispatch = useDispatch();
  const userType = useSelector((s) => s.signinSliceReducer?.userType);
  const userId = useSelector((s) => s.signinSliceReducer?.userId);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const token = Cookies.get("e_access_token") || localStorage.getItem("e_access_token");
    if (token && !userId) {
      try {
        const { userinfo } = parseJwt(token) || {};
        const evType = userinfo?.evUserType;
        if (evType === 2 || evType === "2") {
          dispatch(setUserState({
            userId: userinfo?.id, token,
            userName: `${userinfo?.firstName || ""}${userinfo?.lastName ? " " + userinfo.lastName : ""}`.trim() || "Candidate",
            userType: "candidate",
            tncStatus: userinfo?.tncStatus,
          }));
        }
      } catch (e) { /* ignore */ }
    }
    setHydrated(true);
  }, [dispatch, userId]);

  if (!hydrated) {
    return <div style={{ padding: 40, textAlign: "center", color: "#64748B" }}>Loading...</div>;
  }

  const token = Cookies.get("e_access_token") || localStorage.getItem("e_access_token");
  if (!token) return <Navigate to="/signin" replace />;

  // Allow if userType is candidate OR if no userType yet (we just hydrated; let it pass)
  if (userType && userType !== USER_TYPE_CANDIDATE) {
    return <Navigate to="/admin/scores-by-interview-round" replace />;
  }

  return <Outlet />;
};

export default CandidateAuthGuard;
